module.exports = __webpack_public_path__ + "img/t_0029.dcb37fe2.gif";